
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nordpharm",
      function () {
        return require("private-next-pages/nordpharm.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nordpharm"])
      });
    }
  